export const ALERT_30_DAYS_PLAN_ID = '55d22223-93d3-4696-932d-965303672728';

export function isAlert30DaysWallet(planId: string | null | undefined): boolean {
  return planId === ALERT_30_DAYS_PLAN_ID;
}

